import { basicLogger, LDProvider } from 'launchdarkly-react-client-sdk'

import { env } from '@/shared/env'
import { LAUNCHDARKLY_INIT_TIMEOUT_SECONDS } from '@/shared/libs/launchdarkly/constants'
import { getContext } from '@/shared/libs/launchdarkly/utils'
import type { WithChildren } from '@/types/components'

export const LaunchdarklyProvider = ({ children }: WithChildren) => {
  const clientSideID = env.VITE_LAUNCHDARKLY_CLIENT_ID

  if (!clientSideID) {
    return <>{children}</>
  }

  return (
    <LDProvider
      clientSideID={clientSideID}
      context={getContext()}
      timeout={LAUNCHDARKLY_INIT_TIMEOUT_SECONDS}
      options={{
        logger: basicLogger({ level: 'error' }),
        streaming: false,
      }}
    >
      {children}
    </LDProvider>
  )
}
